// Токен публичной ссылки, по которой человек пришёл на клиентский вход.
import { CLIENT_URL } from './host';

// Ссылка со страницы /s/:token на клиентский вход, с токеном для атрибуции.
// Домен другой — localStorage между ними не общий, поэтому ref едет в URL.
// Без CLIENT_HOST (on-prem) остаёмся на своём домене, а не проваливаемся в пустоту.
export function shareSignupHref(token) {
  return `${CLIENT_URL || '/'}?ref=${encodeURIComponent(token)}`;
}

// Лежит в localStorage 90 дней (решение 16.09.2026): за кодом уходят в почту и
// возвращаются, иногда через дни. Из адресной строки убирается сразу — иначе
// перезагрузка страницы после входа снова «пришла бы по ссылке».
const KEY = 'newton.ref';
export const TTL_MS = 90 * 24 * 60 * 60 * 1000;
const REF_RE = /^[\w-]{1,64}$/;

const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; } };

export function capture() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('ref');
  if (!token) return;
  if (REF_RE.test(token)) {
    try { localStorage.setItem(KEY, JSON.stringify({ token, at: Date.now() })); } catch { /* приватный режим */ }
  }
  params.delete('ref');
  const rest = params.toString();
  window.history.replaceState({}, '', window.location.pathname + (rest ? `?${rest}` : ''));
}

export function current() {
  const saved = read();
  if (!saved || !REF_RE.test(saved.token || '')) return null;
  if (Date.now() - (saved.at || 0) > TTL_MS) { clear(); return null; }
  return saved.token;
}

export function clear() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
